import React, { Component } from 'react';

class ExtraBtns extends Component {
    constructor() {
        super();
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <div className="table-header-subtitle">
                    <div>{t('discover.entities.table.subtitle')}</div>
                </div>
            </>
        );
    }
}

export default ExtraBtns;
